import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";

import { useTypedDispatch } from "../../stores/hooks";
import {
  ColumnSortState,
  setColumnSort,
} from "../../stores/slices/columnSortSlice";
import { useColumnSortState } from "./useColumnSortState";

type TableHeaderProps<Key extends keyof ColumnSortState> = {
  className: string;
  field: ColumnSortState[Key]["field"];
  tableName: Key;
};

export const TableHeader = <Key extends keyof ColumnSortState>({
  className,
  field,
  tableName,
}: TableHeaderProps<Key>): JSX.Element => {
  const { t } = useTranslation();
  const sort = useColumnSortState(tableName);
  const dispatch = useTypedDispatch();
  const hasSort = sort.field === field;

  return (
    <th
      className={clsx(
        "cursor-pointer user-select-none",
        "md:py-2 hover:bg-input transition-colors duration-1000 hover:duration-300 px-2",
        hasSort ? "font-bold bg-slate-100" : "font-medium",
        className
      )}
      onClick={(): void => {
        const action = setColumnSort({ field, key: tableName });
        dispatch(action);
      }}
    >
      {t(`${tableName}.${field}`)}
      {hasSort && <span>&nbsp;{sort.order === "asc" ? "↓" : "↑"}</span>}
    </th>
  );
};
